import {FormItem} from './FormItem';
import {Races} from '../../races/Races';
import {PayMethod} from './PayMethod';

export class Form {
  key;
  url: string;
  formItems: FormItem[];
  race: any;
  raceData: Races;
  payMethod: PayMethod;
}
